import { BundleState } from 'data/__generated__';

export const BUNDLE_STATES_LABELS = {
    Archived: 'Archivé',
    Aborted: 'Annulé',
    Completed: 'Terminé',
    Created: 'Créé',
    InProgress: 'En cours',
    Paused: 'En pause',
    Started: 'Commencé',
};

/**
 * Mirrors the backend transition guard in
 * systems/api/src/functions/bundle/update/update-bundle-state.function.ts:
 * - Aborted / Archived bundles are terminal → no transition allowed.
 * - Completed bundles can only move to Archived.
 * - Any other source state can move to any target.
 * Kept in sync manually — there is no shared package for this rule between front and back.
 */
export const canTransitionBundleState = (from: BundleState, to: BundleState): boolean => {
    if (from === BundleState.Aborted || from === BundleState.Archived) {
        return false;
    }
    if (from === BundleState.Completed) {
        return to === BundleState.Archived;
    }
    return true;
};
